export default "__VITE_ASSET__DtxZBEAn__"